import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6 mb-3" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "col-md-6 mb-3" }
const _hoisted_9 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_10 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_TablePager = _resolveComponent("TablePager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[6] || (_cache[6] = _createElementVNode("h6", { class: "mb-3" }, "Villes sans zone", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm1) = $event)),
            placeholder: "Chercher une ville",
            type: "text",
            class: "form-control d-inline-block mb-3"
          }, null, 512), [
            [_vModelText, _ctx.searchTerm1]
          ]),
          _createVNode(_component_vue_good_table, {
            columns: _ctx.columns,
            rows: _ctx.rows1
          }, {
            emptystate: _withCtx(() => [
              _createVNode(_component_center, null, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("Aucune entrées correspondants trouvés", -1)
                ])),
                _: 1,
                __: [4]
              })
            ]),
            "table-row": _withCtx((props) => [
              (props.column.field === 'action')
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                    (_ctx.auth.can('SETTINGS'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-success btn-sm",
                          onClick: ($event: any) => (_ctx.AddCity(props.row.id)),
                          title: "Ajouter Ville"
                        }, _cache[5] || (_cache[5] = [
                          _createElementVNode("i", { class: "flaticon-plus" }, null, -1)
                        ]), 8, _hoisted_6))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(props.formattedRow[props.column.field]), 1))
            ]),
            _: 1
          }, 8, ["columns", "rows"]),
          _createVNode(_component_TablePager, {
            pagination: _ctx.pager1,
            "per-page": _ctx.perPage1,
            "onUpdate:perPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.perPage1) = $event)),
            onPaginate: _ctx.getCities1
          }, null, 8, ["pagination", "per-page", "onPaginate"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _cache[9] || (_cache[9] = _createElementVNode("h6", { class: "mb-3" }, "Villes de la zone", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchTerm2) = $event)),
            placeholder: "Chercher une ville",
            type: "text",
            class: "form-control d-inline-block mb-3"
          }, null, 512), [
            [_vModelText, _ctx.searchTerm2]
          ]),
          _createVNode(_component_vue_good_table, {
            columns: _ctx.columns,
            rows: _ctx.rows2
          }, {
            emptystate: _withCtx(() => [
              _createVNode(_component_center, null, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("Aucune entrées correspondants trouvés", -1)
                ])),
                _: 1,
                __: [7]
              })
            ]),
            "table-row": _withCtx((props) => [
              (props.column.field === 'action')
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                    (_ctx.auth.can('SETTINGS'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-danger btn-sm",
                          onClick: ($event: any) => (_ctx.RemoveCity(props.row.id)),
                          title: "Supprimer Ville"
                        }, _cache[8] || (_cache[8] = [
                          _createElementVNode("i", { class: "flaticon-delete" }, null, -1)
                        ]), 8, _hoisted_12))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(props.formattedRow[props.column.field]), 1))
            ]),
            _: 1
          }, 8, ["columns", "rows"]),
          _createVNode(_component_TablePager, {
            pagination: _ctx.pager2,
            "per-page": _ctx.perPage2,
            "onUpdate:perPage": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.perPage2) = $event)),
            onPaginate: _ctx.getCities2
          }, null, 8, ["pagination", "per-page", "onPaginate"])
        ])
      ])
    ])
  ]))
}